import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AuthState } from "../../../redux/reducers/auth.reducer";
import { RootState } from "../../../redux/reducers/root.reducer";
import { useNavigate } from "react-router-dom";
import { PlaintiffRequest } from "../../../models/PlaintiffRequest";
import { RequestsState } from "../../../redux/reducers/requests.reducer";
import {
  getAllRequests,
  siguienteTodo,
} from "../../../redux/actions/requests.actions";
import { Helmet } from "react-helmet-async";
import { Navigation, Pagination } from "swiper";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper.min.css";
import "../../../assets/css/swiper.css";
import { Button } from "../../../components/Button";
import { FormState } from "../../../models/form_state";
import React from "react";
import { PlaintiffRequestCard } from "../../Plaintiff/PlaintiffDetailRequest";
import { IconButton } from "../../../components/IconButton";
import { ArrowLeft } from "react-feather";

export const PlaniffListOtherRequests = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const [selectedRequest, setSelectedRequest] =
    useState<null | PlaintiffRequest>(null);

  const [actualWidth, setActualWidth] = useState(window.innerWidth);

  const auth = useSelector<RootState, AuthState>((state) => state.authReducer);

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);
  }, []);

  const resizeHandler = () => {
    const width = window.innerWidth;

    setActualWidth(width);
  };

  const handleFeaturedClick = (request: PlaintiffRequest) => {
    setOpen(true);
    setSelectedRequest(request);
  };

  const { state, totalDocs, requests, requestsPremium, order, orderBy } =
    useSelector<RootState, RequestsState>((state) => state.requestReducer);

  useEffect(() => {
    dispatch(getAllRequests());
    // eslint-disable-next-line
  }, []);

  const siguiente = (total: any) => {
    dispatch(siguienteTodo(total, order, orderBy!));
  };

  return (
    <main className="py-10 px-8 lg:container lg:mx-auto">
      <Helmet title="Resultados Encontrados" />
      <IconButton onClick={() => navigate("/demandante/otrasSolicitudes/solicitudesRealizadas")} className="mb-5">
        <ArrowLeft size={32} className="text-secondary" />
      </IconButton>
      <h1 className=" text-3xl font-bold text-deepBlue ">
        {`Resultados Encontrados (${totalDocs})`}
      </h1>
      <div>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          slidesPerGroup={1}
          loop={true}
          loopFillGroupWithBlank={true}
          pagination={{
            clickable: true,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          modules={[Pagination, Navigation]}
          className="mySwiper"
          style={{ height: "auto" }}
        >
          <SwiperSlide>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 xl:grid-cols-4 2xl:grid-cols-5 mt-8">
              <React.Fragment>
                <div className="swiper-button-next my-24"></div>
                <div className="swiper-button-prev my-24"></div>
                {requestsPremium.map((request, index) => (
                  <PlaintiffRequestCard
                    key={`request-${index}`}
                    request={request}
                    onFeaturedClick={handleFeaturedClick}
                  />
                ))}
              </React.Fragment>
            </div>
          </SwiperSlide>
        </Swiper>
        {state === FormState.Submitting || state === FormState.Initial ? (
          new Array(5).fill(0).map((value, i) => {
            return (
              <div
                className="h-96 bg-white shadow-md rounded-xl overflow-hidden"
                key={`skeleton-div-${i}`}
              >
                <div className="w-full h-1/2 bg-gray-200 animate-pulse"></div>

                <div className="w-full h-1/2 flex flex-col ">
                  <div className="w-3/4 h-4 pulse rounded-full bg-gray-200 mt-2 mx-4"></div>
                  <div className="mx-4 mt-10">
                    <div className="w-3/4 h-3 pulse rounded-full bg-gray-200"></div>
                    <div className="w-2/4 h-2 pulse rounded-full bg-gray-200 mt-2"></div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 xl:grid-cols-4 2xl:grid-cols-5 mt-8">
            <React.Fragment>
              {requests.map((request, index) => (
                <PlaintiffRequestCard
                  key={`request-${index}`}
                  request={request}
                  onFeaturedClick={handleFeaturedClick}
                />
              ))}
            </React.Fragment>
          </div>
        )}
      </div>

      <div className="mt-10 flex items-center justify-center ">
        <Button
          type="submit"
          text="Cargar más solicitudes"
          color="secondary"
          className="mt-10  flex items-center justify-center "
          onClick={() => siguiente(totalDocs)}
        />
      </div>
    </main>
  );
};
